<template>
	<!-- NODE -->
	<article :class="`node ${node.type} ${node.id === '1' ? 'home' : ''}`">
		<!-- INFO -->
		<div :class="`info ${info.type}`" v-if="info">
			<span>{{info.value}}</span>
		</div>
		<!-- TITLE -->
		<div class="page-title" v-if="node.type !== 'realisation'">
			<!-- HOME -->
			<div class="container" v-if="node.id === '1'">
				<div class="title-wrapper wow fadeIn" data-wow-duration="1.5s">
					<img src="/image/logo.png" class="img-fluid" :alt="node.title" />
					<h1 v-html="node.titleBody"></h1>
				</div>
				<div class="btn-wrapper center">
					<button
						class="btn btn-primary wow bounceIn"
						data-wow-delay="1s"
						v-on:click="scrolling"
					>Découvrir</button>
				</div>
			</div>
			<!-- ELSE -->
			<div class="container" v-else>
				<h1>{{node.title}}</h1>
				<p v-html="node.titleBody"></p>
			</div>
		</div>
		<!-- CONTENT -->
		<!-- PARAGRAPHER -->
		<div class="content" v-if="node.type === 'paragrapher'">
			<!-- SECTION -->
			<Section v-for="(paragraphe, key) in node.paragraphes" :key="key" :paragraphe="paragraphe" />
		</div>
		<!-- CATEGORY -->
		<div class="content" v-else-if="node.type === 'category'">
			<div class="container-fluid">
				<p v-if="node.body" v-html="node.body"></p>
				<!-- CATEGORY MENU -->
				<nav>
					<ul class="nav">
						<li v-for="(category, key) in getCategories" :key="key" class="item-category">
							<router-link
								:to="`/realisation/${category.id}`"
								:class="`btn ${ category.id === node.id ? 'focused' : '' }`"
							>{{category.menuTitle}}</router-link>
						</li>
					</ul>
				</nav>
				<!-- LISTE REALISATION -->
				<div class="row row-col-custom-5">
					<div
						v-for="(realisation, i) in getRealisations"
						:key="i"
						class="col-custom-5 wow fadeInUp"
						:data-wow-delay="`${(i - (5 * Math.floor(i/5))) * 0.15}s`"
					>
						<div class="node teaser realisation">
							<div class="realisation-image-wrapper">
								<img
									:src="`/image/realisation/${
										Array.isArray(realisation.image) ? realisation.image[0] : realisation.image
									}`"
									class="img-fluid"
								/>
							</div>
							<router-link :to="`/realisation/${realisation.id}`">{{realisation.title}}</router-link>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- REALISATION -->
		<div class="content" v-else-if="node.type === 'realisation'">
			<div class="container-fluid">
				<button class="btn btn-back" v-on:click="goBack">&lt; Retour</button>
				<h1>{{node.title}}</h1>
				<!-- <p v-html="node.body"></p> -->
				<!-- IMAGE -->
				<div class="wow fadeInLeft">
					<Slider :images="node.image" />
				</div>
				<div class="row" v-if="getNextRealisations.length">
					<div class="mono-col">
						<h2 class="suggestion">Des réalisations qui pourraient vous intéresser&nbsp;:</h2>
						<div class="row realisation-teaser-wrapper">
							<div
								v-for="(realisation, i) in getNextRealisations"
								:key="i"
								class="col-xs-12 col-sm-6 col-md-4 wow fadeInUp"
								:data-wow-delay="`${i * 0.15}s`"
							>
								<div class="node teaser realisation">
									<img
										:src="`/image/realisation/${
											Array.isArray(realisation.image) ? realisation.image[0] : realisation.image
										}`"
										class="img-fluid"
									/>
									<router-link :to="`/realisation/${realisation.id}`" class="hidden">{{realisation.title}}</router-link>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- CONTACT -->
		<div class="content" v-else-if="node.type === 'contact'">
			<div class="container">
				<p v-if="node.body" v-html="node.body"></p>
				<!-- FORM -->
				<Formulaire :form="node.form" />
			</div>
		</div>
		<!-- DEFAUT -->
		<div class="content" v-else-if="node.body">
			<p v-html="node.body"></p>
		</div>
	</article>
</template>

<script>
//data
import nodes from "../json/nodes.json";
import NodeBuilder from "../data-schema/NodeBuilder.js";
//component
import Section from "../component/Section.vue";
import Slider from "../component/Slider.vue";
import Formulaire from "../component/Formulaire.vue";
//plugin
import WOW from "wow.js";

const nodesArray = Object.values(nodes);
const nodesReverseArray = nodesArray.slice().reverse();
const nodeBuilder = new NodeBuilder();

export default {
	name: "Content",
	props: {
		nid: {
			type: Number,
			required: false
		}
	},
	data() {
		return {
			node: null,
			info: null,
			wow: null
		};
	},
	methods: {
		load: function(id) {
			id = id.toString();
			let node = nodeBuilder.get(id);
			return node;
		},
		scrolling: function(evt) {
			let element = evt.target.closest(".page-title");
			let height =
				element.offsetHeight - document.documentElement.scrollTop;
			window.scrollBy({ top: height, left: 0, behavior: "smooth" });
		},
		goBack: function() {
			this.$router.back();
		},
		updateMetaData() {
			if (this.node.meta) {
				document.title = this.node.meta.title;
				this.node.meta.metaTags.forEach(metatag => {
					document
						.querySelector(`meta[name='${metatag.name}']`)
						.setAttribute("content", metatag.content);
				});
			}
		},
		forceWowReanimation(element) {
			element.classList.remove("animated");
			element.style.removeProperty("animation-iteration-count");
			element.style.removeProperty("animation-delay");
			element.style.removeProperty("animation-iteration-count");
			element.style.removeProperty("animation-name");
			this.wow.applyStyle(element, true);
			setTimeout(() => {
				this.wow.show(element);
			}, 10);
		}
	},
	computed: {
		getCategories() {
			return nodesArray.filter(
				node => node.type === "category" && node.id !== "4"
			);
		},
		getRealisations() {
			if (this.node.id === "4") {
				return nodesReverseArray.filter(
					node => node.type === "realisation"
				);
			}

			return nodesReverseArray.filter(
				node =>
					node.type === "realisation" &&
					node.category === this.node.id
			);
		},
		getNextRealisations() {
			let realisations = [];
			//Récupère les trois réalisations suivantes
			for (let node of nodesReverseArray) {
				if (
					node.type === "realisation" &&
					node.category === this.node.category &&
					parseInt(node.id) < parseInt(this.node.id) &&
					realisations.length < 3
				) {
					realisations.push(node);
				}
			}

			if (realisations.length < 3) {
				for (let node of nodesReverseArray) {
					if (
						node.type === "realisation" &&
						node.category === this.node.category &&
						parseInt(node.id) > parseInt(this.node.id) &&
						realisations.length < 3
					) {
						realisations.push(node);
					}
				}
			}

			return realisations;
		}
	},
	created() {
		//Initialise node
		if (this.nid) {
			this.node = this.load(this.nid);
		} else if (this.$route.params && this.$route.params.nid) {
			this.node = this.load(this.$route.params.nid);
		} else {
			this.node = this.load(0);
		}
		//Met à jour les meta
		this.updateMetaData;
		//vérifie si le formulaire a bien été envoyé
		if (this.$route.query && this.$route.query.envoi) {
			if (this.$route.query.envoi === "ok") {
				this.info = {
					value: "Votre message s'est bien envoyé.",
					type: "success"
				};
			} else {
				this.info = {
					value:
						"Nous avons rencontré un problème, votre message ne s'est pas envoyé. Veuillez réessayer",
					type: "fail"
				};
			}
		}
	},
	watch: {
		//Permet de mettre à jour les data si les props bougent
		nid: function(newNid) {
			if (newNid) {
				this.node = this.load(newNid);
			}
		},
		$route(to) {
			//Permet de mettre à jour les data si les params bougent
			if (to.params && to.params.nid) {
				this.node = this.load(to.params.nid);
			}
			//Met à jour les meta
			this.updateMetaData;
			for (let el of document.getElementsByClassName("wow")) {
				this.forceWowReanimation(el);
			}
		}
	},
	mounted() {
		if (this.info) {
			setTimeout(() => {
				document.querySelector(".info").classList.add("hidden");
			}, 2500);
		}
		//Lance wow js
		this.wow = new WOW();
		this.wow.init();
	},
	components: {
		Section,
		Slider,
		Formulaire
	}
};
</script>
